module.exports = __webpack_public_path__ + "static/media/ABNB_CompTable_IPOIntelligence_a_base.c8d43900.png";